import { LoadingButton } from "@mui/lab";
import { Backdrop, Box, Button, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import { deleteCompanyCodeTranslation } from "../../../../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
} from "../../../../components/snackBar/snakbar";
import { useThemes } from "../../../../components/Theme/theme";
import { useCreateCompanyCodeTranslationArrayMutation } from "../../../../redux/apis/getCompanyCodeTranslation.api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
};
function DeleteTcsTds({
  open,
  setOpen,
  priceTypeID,
  editedRows,
  getAccountData,
  setPriceTypeID,
  optionType,
}) {
  const { theme } = useThemes();

  const [loading, setLoading] = useState(false);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  const [
    createUnit,
    {
      isLoading: isCreatingUnit,
      isError: isCreateUnitError,
      isSuccess: isCreateUnitSuccess,
      error: createUnitError,
    },
  ] = useCreateCompanyCodeTranslationArrayMutation();
  const deleteItem = async () => {
    setLoading(true);

    // const deleteRelationData = await API.graphql(
    //   graphqlOperation(deleteCompanyCodeTranslation, {
    //     ID: priceTypeID,

    //   })
    // );
    Math.floor(new Date().getTime() / 1000);
    const exp = Math.floor(new Date().getTime() / 1000);
    let obj = {
      id: priceTypeID,
      codeorder: Number(editedRows?.codeOrder),
      codetext: editedRows?.codeText,
      codetype: optionType === "Add New TDS Option" ? 1 : 2,
      codevalue: Number(editedRows?.codePercentage),
      language: "",
      uqc: "",
      expiredtimestamp: exp,
      is_active: 1,
    };
    // listPriceDetails()
    const res = await createUnit({
      createCompanyCodeTranslationArrayInput: [obj],
    });
    const statusCode = res.data?.[0].statuscode;

    if (statusCode === "Success") {
      setOpen(false);
      setLoading(false);
      setPriceTypeID("");
      getAccountData();
      showSuccessSnackbar(
        optionType === "Add New TDS Option"
          ? "TDS  data deleted"
          : "TCS data deleted"
      );
    } else {
      showErrorSnackbar("Some thing went wrong!.Please try again");
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Box sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography
            sx={{
              color: theme?.palette?.TmId.id.toString().includes("9")
                ? "#FFF1E6"
                : "rgb(60 60 60)",
              fontWeight: "bold",
            }}
          >
            Do you want to delete this data?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            disabled={loading}
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          <LoadingButton
            color="error"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
            loading={loading}
            disableRipple={true}
            variant="contained"
            onClick={() => deleteItem()}
          >
            Yes
          </LoadingButton>
        </Box>
      </Box>
      {/* </Fade> */}
    </Modal>
  );
}

export default DeleteTcsTds;
